/* @flow */

import * as React from 'react';

import {colors} from '../colors';
import {HoverPopover} from '../hover-popover';
import {LeadIconChevron} from '../icon';
import type {Lead} from '../timeline/types';

import {PopoverContent} from './popover-content';

import './lead-count-avatar.module.css';

type Props = {
    leads: Lead[],
    size: number,
};

export function LeadCountAvatar(props: Props) {
    const {leads, size} = props;

    const anchor = React.useRef(null);

    return (
        <>
            <div
                ref={anchor}
                styleName='lead-chevron-container'
                style={{width: size, height: size, borderRadius: size}}
            >
                <LeadIconChevron
                    wrapWithDiv={false}
                    size={Math.ceil(size / 1.4)}
                    fill={colors.white}
                />
                <div
                    styleName='count-container'
                    style={{width: size, height: size, fontSize: Math.ceil(size / 2.6)}}
                >
                    <div>{leads.length}</div>
                </div>
            </div>
            <HoverPopover anchorRef={anchor} location='bottom' disableFocusTrapZone={true}>
                <PopoverContent leads={leads} />
            </HoverPopover>
        </>
    );
}
